// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup2ExtraCodesHeader h2:first-of-type{margin-bottom:1rem}.popup2ExtraCodes{font-weight:400;text-align:center}.popup2ExtraCodes p{margin-right:auto;margin-left:auto}.popup2ExtraCodes a{text-decoration:underline}.popup2ExtraCodes a:focus,.popup2ExtraCodes a:hover{text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
